import { handleSnowSensor } from 'shared/slice/essSwitchSlice';
import { tesHandleSnowSensor } from 'shared/slice/tesSwitchSlice';
import { tgsHandleSnowSensor } from 'shared/slice/tgsSwitchSlice';

export const snowSensorHandler = (
  dispatch,
  state,
  scope,
  type,
  location,
  machine,
  specificLocation,
  swt,
  messageBoxHandler
) => {
  if (state === 'on') {
    const dispatchData = { location, specificLocation, machine };
    if (swt === 'ESS') {
      dispatch(handleSnowSensor(dispatchData));
    } else if (swt === 'TGS') {
      tgsHandleSnowSensor(dispatchData);
    } else if (swt === 'TES') {
      tesHandleSnowSensor(dispatchData);
    }
  } else {
    messageBoxHandler(state, scope, type, 'snow sensor program');
  }
};
